<template>
  <!-- <van-cell
    :title="title"
    :placeholder="placeholder"
    is-link
    :value="timeValue"
    @click="showPopup"
    required
    :label="isRequired ? '请选择' + title : ''"
  /> -->
  <van-popup 
    v-model:show="show" 
    position="bottom"
    @click-overlay="handleCancel"
    >
    <van-datetime-picker
      v-model="time"
      :type="type"
      :title="'选择' + title"
      :min-date="minDate"
      :max-date="maxDate"
      :formatter="formatter"
      @confirm="confirmPicker"
      @cancel="handleCancel"
    />
  </van-popup>
</template>
<script>
import { reactive, toRefs, onMounted, watch } from "vue";
export default {
  name: "DatePicker",
  props: {
    title: {
      type: String,
      default: "日期",
    },
    // date、year-month、month-day、datehour、datetime
    type: {
      type: String,
      default: "date",
    },
    isShowPopup: {
      type: Boolean,
    },
    placeholder: {
      type: String,
      default: "请选择日期",
    },
    callback: {
      type: Function,
    },
    isRequired: {
      type: Boolean,
      default: false,
    },
    // 用于回显的值
    value: {
      type: Number,
    },
    maxDate: {
      type: Date,
      default: new Date(2122, 11, 12),
    }
  },
  setup(props) {
    const state = reactive({
      show: false,
      time: new Date(),
      timeValue: "请选择" + props.title,
      minDate: new Date(1939, 12, 31),
      // maxDate: new Date(2122, 11, 12),
      isFlag: true,
    });
    onMounted(() => {
      if( props.maxDate ) {
        state.maxDate = props.maxDate;
      }
      if (props.value) {
        state.time = new Date(props.value);
        formatTime(props.value);
      } else {
        state.time = props.maxDate;
        formatTime(props.maxDate);
      }
    });
    watch(props, (newProps) => {
      const { value } = newProps;
      if (state.isFlag && value) {
        formatTime(props.value);
      }
    });
    const formatTime = (val) => {
      const { type } = props;
      val = new Date(val);
      let year = val.getFullYear();
      let month = val.getMonth() + 1;
      let day = val.getDate();
      let hour = val.getHours();
      let minute = val.getMinutes();
      if (month >= 1 && month <= 9) {
        month = `0${month}`;
      }
      if (day >= 1 && day <= 9) {
        day = `0${day}`;
      }
      if (hour >= 0 && hour <= 9) {
        hour = `0${hour}`;
      }
      if (minute >= 0 && minute <= 9) {
        minute = `0${minute}`;
      }
      // date、year-month、month-day、datehour
      if (type == "date") {
        state.timeValue = `${year}-${month}-${day}`;
      }
      if (type == "year-month") {
        state.timeValue = `${year}-${month}`;
      }
      if (type == "year-month-day") {
        state.timeValue = `${year}-${month}-${day}`;
      }
      if (type == "month-day") {
        state.timeValue = `${month}-${day}`;
      }
      if (type == "datehour") {
        state.timeValue = `${year}-${month}-${day} ${hour}`;
      }
      if (type == "datetime") {
        state.timeValue = `${year}-${month}-${day} ${hour}:${minute}`;
      }
    };
    // 确认选择的时间
    const confirmPicker = (val) => {
      const { type, callback } = props;
      let year = val.getFullYear();
      let month = val.getMonth() + 1;
      let day = val.getDate();
      let hour = val.getHours();
      let minute = val.getMinutes();
      if (month >= 1 && month <= 9) {
        month = `0${month}`;
      }
      if (day >= 1 && day <= 9) {
        day = `0${day}`;
      }
      if (hour >= 0 && hour <= 9) {
        hour = `0${hour}`;
      }
      if (minute >= 0 && minute <= 9) {
        minute = `0${minute}`;
      }
      // date、year-month、month-day、datehour
      if (type == "date") {
        state.timeValue = `${year}-${month}-${day}`;
      }
      if (type == "year-month") {
        state.timeValue = `${year}-${month}`;
      }
      if (type == "year-month-day") {
        state.timeValue = `${year}-${month}-${day}`;
      }
      if (type == "month-day") {
        state.timeValue = `${month}-${day}`;
      }
      if (type == "datehour") {
        state.timeValue = `${year}-${month}-${day} ${hour}`;
      }
      if (type == "datetime") {
        state.timeValue = `${year}-${month}-${day} ${hour}:${minute}`;
      }
      // console.log('timeValue', state.timeValue)
      state.isFlag = false;
      callback && callback(new Date(val).getTime() / 1000);

      showPopup();
    };
    // 选项格式化函数
    const formatter = (type, value) => {
      if (type === "year") {
        return `${value}年`;
      } else if (type === "month") {
        return `${value}月`;
      } else if (type === "day") {
        return `${value}日`;
      } else if (type === "hour") {
        return `${value}时`;
      } else if (type === "minute") {
        return `${value}分`;
      } else if (type === "second") {
        return `${value}秒`;
      }
      return value;
    };
    const showPopup = () => {
      state.show = !state.show;
    };
    const onConfirm = () => {
      showPopup() // 通常你会在这里关闭对话框
    };
 
    const onCancel = () => {
      showPopup() // 通常你会在这里关闭对话框
    };
    return {
      ...toRefs(state),
      showPopup,
      formatter,
      confirmPicker,
      onConfirm,
      onCancel
    };
  },
  methods: {
    handleCancel() {
      this.$emit('cancel'); // 触发取消事件
      this.$emit('update:show', false); // 关闭popup，通常取消操作也会关闭弹窗
    },
  },
};
</script>
<style lang="less" scoped>
:deep(.van-cell__label) {
  color: #ee0a24;
}
</style>
